// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"f2a4c79a","136":"f1b66d42","180":"0e59ae1f","228":"71bed6db","237":"0e59ae1f","534":"0e59ae1f","764":"0e59ae1f","955":"bf4858d7","976":"31d6cfe0"}[chunkId] + ".chunk.css";
};